// extracted by mini-css-extract-plugin
export default {"card":"Card_card__RyEvq","card_header":"Card_card_header__P8KP1","title":"Card_title__dKPbR"};